var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs',{attrs:{"custom-breadcrumbs":_vm.breadcrumbs}}),_c('folder-details',{attrs:{"items":_vm.item.children,"loading":_vm.loading,"page-title":_vm.item.name,"item-id":_vm.item.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }